import React, { useEffect } from "react";
import classes from "./aboutPage.module.css";
import FacebookPage from "../../components/FacebookPage";
import CustomLink from "../../components/CustomLink";
import demo01 from "../../static/img/demo_01.png";
import demo02 from "../../static/img/demo_02.png";
import demo03 from "../../static/img/demo_03.png";
import demo04 from "../../static/img/demo_04.png";
import demo05 from "../../static/img/demo_05.png";
import demo06 from "../../static/img/demo_06.png";
import demo07 from "../../static/img/demo_07.png";
import { useTranslation } from "react-i18next";

function AboutPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("about.title");
  }, [t]);

  return (
    <div className={classes.root}>
      <h3 className={classes.heading}>{t("about.section_1.title")}</h3>
      <div>
        <CustomLink to={"/"}>Grade World</CustomLink>{" "}
        {t("about.section_1.content_1")}{" "}
        <a
          href={"https://www.facebook.com/gradeptit"}
          target={"_blank"}
          rel={"noopener noreferrer"}
        >
          Grade PTIT Facebook Page
        </a>{" "}
        {t("about.section_1.content_2")}{" "}
        <a
          href={"mailto:gradeptit@gmail.com?subject=Feedback to Gradeptit"}
          target={"_blank"}
          rel={"noopener noreferrer"}
        >
          grade-world@gmail.com
        </a>
      </div>
      <h3 className={classes.heading}>{t("about.section_2.title")}</h3>
      <ul>
        <li>
          <b>{t("gpa_cpa.title")}</b> {t("about.section_2.content_1")}{" "}
          <CustomLink to={"/gpa-cpa-learning-plan"}>
            {t("gpa_cpa.label")}
          </CustomLink>
          <div className={classes.imageContainer}>
            <img src={demo01} alt={t("about.section_2.content_2")} />
            <span className={classes.label}>
              {t("about.section_2.content_2")}
            </span>
          </div>
          <div className={classes.imageContainer}>
            <img src={demo02} alt={t("about.section_2.content_3")} />
            <span className={classes.label}>
              {t("about.section_2.content_3")}
            </span>
          </div>
          <div className={classes.imageContainer}>
            <img src={demo03} alt={t("about.section_2.content_4")} />
            <span className={classes.label}>
              {t("about.section_2.content_4")}
            </span>
          </div>
          <div className={classes.imageContainer}>
            <img src={demo04} alt={t("about.section_2.content_5")} />
            <span className={classes.label}>
              {t("about.section_2.content_5")}
            </span>
          </div>
        </li>
        <li>
          <b>{t("gpa_cpa.set_target")}:</b> {t("about.section_2.content_6")}{" "}
          <CustomLink to={"/gpa-cpa-learning-plan"}>
            {t("gpa_cpa.set_target")}
          </CustomLink>
          <div className={classes.imageContainer}>
            <img src={demo05} alt={t("gpa_cpa.set_target")} />
            <span className={classes.label}>{t("gpa_cpa.set_target")}</span>
          </div>
        </li>
        <li>
          <b>{t("grade_calculator.title")}:</b> {t("about.section_2.content_7")}{" "}
          <CustomLink to={"/grade-summary-calculator"}>
            {t("grade_calculator.label")}
          </CustomLink>
          <div className={classes.imageContainer}>
            <img src={demo07} alt={t("grade_calculator.title")} />
            <span className={classes.label}>{t("grade_calculator.title")}</span>
          </div>
        </li>
        <li>
          <b>{t("convert_10_to_4.title")}:</b> {t("about.section_2.content_8")}{" "}
          <CustomLink to={"/grade-summary-calculator"}>
            {t("convert_10_to_4.label")}
          </CustomLink>
          <div className={classes.imageContainer}>
            <img src={demo06} alt={t("convert_10_to_4.title")} />
            <span className={classes.label}>{t("convert_10_to_4.title")}</span>
          </div>
        </li>
      </ul>
      <h3 className={classes.heading}>{t("about.section_3.label")}</h3>
      <ul>
        <li>
          - <b>09/07/2024:</b> {t("about.section_3.content_1")}
        </li>
      </ul>
      <h3 className={classes.heading}>{t("about.section_4.label")}</h3>
      <FacebookPage
        className={classes.facebookPage}
        label={t("facebook_label.grade_tool")}
        url={
          "https://www.facebook.com/gradeptit/posts/pfbid02KnBGvG3GBtYqkt52Fc44qmYKFJ1JPSBvNtov1FAHnFg9gjXgNC4NowZyArRBUYyDl"
        }
      />
    </div>
  );
}

export default AboutPage;
